import { useEffect, useRef } from "react"
import { useFeatureFlagsClientIsReady } from "./featureFlagsClient"

type Props = {
    onReady: () => void
}
export const FeatureFlagsReadyHook: React.FC<Props> = ({ onReady }) => {
    const alreadyReported = useRef(false)
    const isReady = useFeatureFlagsClientIsReady()

    useEffect(() => {
        if (isReady && !alreadyReported.current) {
            onReady()
            alreadyReported.current = true
        }
    }, [isReady, onReady])

    return null
}
